
<template>
    <div class="loading-container">
        <div class="loading-spinner"></div>
        <p>{{ $t('financial.stripe.redirecting') }}</p>
    </div>
</template>

<script>
export default {
    props: ['session_id'],
    mounted() {
        this.checkPaymentStatus();
    },
    methods: {
        checkPaymentStatus() {
            const sessionId = this.session_id;

            if (!sessionId) {
                return;
            }

            fetch(`/api/check-user/${sessionId}`)
                .then(response => response.json())
                .then((data) => {
                    if (data.redirect) {
                        console.log(data);
                        window.location.href = data.redirect;
                    } else {
                        setTimeout(this.checkPaymentStatus, 2000);
                    }
                })
                .catch((error) => {
                    console.error('Error checking payment status: ', error);
                });
        },
    },
};
</script>

<style scoped>
.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    text-align: center;
}

.loading-spinner {
    border: 16px solid #f3f3f3; /* Light grey */
    border-top: 16px solid #3498db; /* Blue */
    border-radius: 50%;
    width: 120px;
    height: 120px;
    animation: spin 2s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>
